import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatterFileType, MatterSource } from '@models/matter';
import { BillingService } from '@services/billing/billing.service';
import { YesOrNo } from '@core/types';
import { ButtonComponent } from '@ui/button/button.component';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';

@Component({
	selector: 'app-warn-before-importing-matter',
	templateUrl: './warn-before-importing-matter.component.html',
	standalone: true,
	imports: [ButtonComponent, CommonModule, CoreModule, AtomicModule],
})
export class WarnBeforeImportingMatterComponent implements OnInit {
	protected answer = YesOrNo;
	protected salePrice = 0;
	protected purchasePrice = 0;
	protected refinancePrice = 0;
	protected loading = true;

	constructor(
		public warnBeforeImportDialog: MatDialogRef<WarnBeforeImportingMatterComponent>,
		private billingService: BillingService,
	) {}

	async ngOnInit(): Promise<void> {
		const salePricePromise = this.billingService.getPrice(
			MatterFileType.SALE,
			MatterSource.LEAP,
		);
		const purchasePricePromise = this.billingService.getPrice(
			MatterFileType.PURCHASE,
			MatterSource.LEAP,
		);
		const refinancePricePromise = this.billingService.getPrice(
			MatterFileType.REFINANCE,
			MatterSource.LEAP,
		);

		const [salePriceResult, purchasePriceResult, refinancePriceResult] =
			await Promise.all([
				salePricePromise,
				purchasePricePromise,
				refinancePricePromise,
			]);
		this.salePrice = salePriceResult;
		this.purchasePrice = purchasePriceResult;
		this.refinancePrice = refinancePriceResult;

		this.loading = false;
	}

	closeDialog(yesOrNo: YesOrNo) {
		this.warnBeforeImportDialog.close({
			answer: yesOrNo,
		});
	}
}
